import "./sass/style.scss";
// import anime from "./js/anime.min.js";

require("./js/twentig-animations");
require("./js/nav");
require("./js/custom");

// Make anime available globally if needed
// window.anime = anime;
